import { scrollToTop } from '../toolbox/scroll';
/**
 * @typedef {InstanceType<ReturnType<typeof import('widgets/forms/AjaxForm').default>>} ajaxForm
 * @typedef {typeof import('widgets/Widget').default} Widget
 */

/**
 * @param {Widget} Widget Base widget for extending
 * @returns {typeof ContactUs} ContactUs widget
 */
export default function (Widget) {
    /**
     * @category widgets
     * @subcategory content
     * @class ContactUs
     * @augments Widget
     * @classdesc Contact Us component with next features:
     * 1. Render success result content
     * 2. After rendering scroll to top if not in modal
     *
     * Contact Us component should contain `data-ref="contactUsFormWrapper"` with `data-is-in-modal="${pdict.isAjax}"` to indicate Is `concact us` component located in modal window
     * @example <caption>Contact us component</caption>
     * <div class="b-contact" data-widget="contactUs">
     *   <div data-ref="contactUsFormWrapper" data-is-in-modal="${pdict.isAjax}">
     *       <form
     *           action="${pdict.actionUrl}"
     *           class="b-form m-contact-us"
     *           method="POST"
     *           name="contact-us"
     *           data-widget="ajaxform"
     *           data-widget-event-submit="onSuccessSubmit"
     *           data-event-submit.prevent="handleSubmit"
     *       >
     *       ...
     *           form fields
     *       ...
     *       </form>
     *   </div>
     * </div>
     */
    class ContactUs extends Widget {
        /**
         * @description Render success message and scroll to top if content not in modal window
         * @param {ajaxForm} form - Ajax form widget instance
         * @param {object} data - Contact us form submission response
         */
        onSuccessSubmit(form, data) {
            if (data.success) {
                const isInModal = this.ref('contactUsFormWrapper').data('isInModal');
                this.render(undefined, undefined, undefined, data.msg).then(()=> {
                    if (!isInModal) {
                        scrollToTop();
                    }
                });
            }
        }
    }

    return ContactUs;
}
